import axios from "../../axiosConfig/axios";

export const UserRegistrationUpdate = {
    uploadFiles(type, data, token, config, callback) {
        try {
            axios.patch(`users/${type}`,
                data,
                config
            ).then(response => {
                if (response != undefined) {
                    let message = { ...response.data, message: "File Uploaded successfully " }
                    callback(null, message)
                }
                else {
                    callback({
                        message: "Something Went Wrong"
                    }, null)

                }
            }).catch(error => {
                callback({
                    message: error
                }, null)
            })
        } catch (error) {
            callback({
                message: "Something Went Wrong!"
            }, null)
        }
    },
    async fetchUserData(token) {
        return axios.get(`user`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })

    },
    async getUerForAdmin(data) {
        // 61f0ed08b71dc157de9f7353
        return axios.get(`user?userId=${data?.id}&isAdmin=${true}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data?.user?.jwtToken
                }
            })

    }
    ,
    async updateUserdata(userdata) {
        delete userdata?.data?.resubmissions
        // delete userdata?.data?.companyDetails
        return axios.patch(`users/${userdata?.type}`,
            userdata?.data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': userdata?.token
                }
            })

    }
    , async verifyUserData(token) {
        return axios.patch(`users/verify?verifyToken=${token}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            })

    },
    async resubmit(userdata) {
        return axios.patch(`users/${userdata?.loginUser?.type}?userId=${userdata?.loginUser?._id}`,
            {
                resubmissions: userdata?.data == 'resubmission' ? userdata?.objection:undefined,
                resubmit: userdata?.data == 'resubmission' ? undefined:true
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': userdata?.loginUser?.jwtToken
                }
            })

    }

};